export default "__VITE_ASSET__Dxpx3FWd__"